// extracted by mini-css-extract-plugin
export default {"companyListContainer":"BucketDetails_companyListContainer__cXsZZ","companyListHead":"BucketDetails_companyListHead__RckpI","editButton":"BucketDetails_editButton__4-V+H"};